export class ActivationManager {
    constructor(registry) {
        this.pendingDeactivations = {};
        this.registry = registry;
    }
    activate(blockId, callback) {
        this.pendingDeactivations[blockId] && clearTimeout(this.pendingDeactivations[blockId]);
        if (!this.registry.any) {
            callback();
        }
        if (this.registry.contains(blockId)) {
            return;
        }
        this.registry.register(blockId);
    }
    deactivate(blockId, callback) {
        const ref = this;
        this.pendingDeactivations[blockId] = setTimeout(() => {
            if (!ref.registry.contains(blockId)) {
                return;
            }
            ref.registry.unregister(blockId);
            if (!ref.registry.any) {
                callback();
            }
        }, 200);
    }
}
//# sourceMappingURL=ActivationManager.js.map